import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { XfAchievementsSolid } from "@gaming/xds-react-js-icons";

import * as styles from "./SolidAchievementIcon.module.css";

export const SolidAchievementIcon = () => (
  <Icon
    className={styles.solidAchievementIcon}
    icon={XfAchievementsSolid}
    iconSize={IconSize.Custom}
  />
);
